<template>
    <div class="lookBill">
        <el-dialog
            title="账单"
            :visible.sync="lookBillDialog"
            :close-on-click-modal="false"
        >
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="收入明细" name="first">
                    <el-table :data="tableData">
                        <el-table-column prop="createTime" label="时间" align="center">
                        </el-table-column>
                        <el-table-column prop="storeFee" label="金额" align="center">
                        </el-table-column>
                    </el-table>
                    <el-pagination
                        v-if="tableData.length != 0"
                        background
                        @current-change="handleCurrentChange"
                        @prev-click="handleCurrentChange"
                        @next-click="handleCurrentChange"
                        layout="total,prev, pager, next,jumper"
                        :current-page="current"
                        :page-size="pageSize"
                        :total="total" class="pagination">
                    </el-pagination>
                </el-tab-pane>
                <el-tab-pane label="提现明细" name="third">
                    <el-table :data="tableData">
                        <el-table-column prop="createTime" label="时间" align="center">
                        </el-table-column>
                        <el-table-column prop="orderAmount" label="金额" align="center">
                        </el-table-column>
                    </el-table>
                    <el-pagination
                        v-if="tableData.length != 0"
                        background
                        @current-change="handleCurrentChange"
                        @prev-click="handleCurrentChange"
                        @next-click="handleCurrentChange"
                        layout="total,prev, pager, next,jumper"
                        :current-page="current"
                        :page-size="pageSize"
                        :total="total" class="pagination">
                    </el-pagination>
                </el-tab-pane>
            </el-tabs>
        </el-dialog>
    </div>
</template>

<script>
import {getBalanceList, getCashOutList} from "../../utils/interface";

export default {
    name: "lookBill",
    data() {
        return {
            lookBillDialog: false,
            activeName: "first",
            tableData: [],
            loading: false,
            current: 1,
            pageSize: 10,
            total: 0
        };
    },
    created() {
        this.getBalanceDetailList();
    },
    methods: {
        init() {
            this.lookBillDialog = true;
        },
        handleClick(obj) {
            let name = obj.name;
            if (name === 'third') {
                this.getCashOutDetailList();
            } else {
                this.getBalanceDetailList();
            }
        },

        getBalanceDetailList() {
            this.loading = true;
            let params = {
                status: 'SUCCESS',
                current: this.current,
                pageSize: this.pageSize,
            };
            getBalanceList(params).then((res) => {
                this.total = res.total;
                this.tableData = res.list;
                this.loading = false
            });
        },


        getCashOutDetailList() {
            let params = {
                status: 'SUCCESS',
                current: this.current,
                pageSize: this.pageSize,
            };
            getCashOutList(params).then((res) => {
                this.total = res.total;
                this.tableData = res.list;
                this.loading = false
            });
        },

        // 分页
        handleCurrentChange(val) {
            this.current = val;
            if (this.activeName === 'first') {
                this.getBalanceDetailList();
            } else {
                this.getCashOutDetailList();
            }
        },
    },
};
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/views/balance/lookBill.vue